import React, { useState } from 'react';
import { Radio } from 'antd';
import DateRangePicker from 'components/DateRangePicker';
import EventsOverviewChart from 'modules/ReportModule/components/EventsOverview/EventsOverviewChart';
import { CalendarOutlined } from '@ant-design/icons';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import dayjs from 'dayjs';
import { staticRanges } from 'components/DateRangePicker/components/staticRanges';
import FrequentPagesTable from 'modules/ReportModule/pages/WebsiteTrafficReporting/components/FrequentPagesTable';
import JourneyReport from 'modules/ReportModule/context/JourneyReport';

const InsightCard = () => {
  const [range, setRange] = useState();
  const [customRange, setCustomRange] = useState([]);
  const { setDate } = useWidgetDate('global');

  const handleRangeChange = (e) => {
    const value = e.target.value;
    setRange(value);

    if (value === 'custom') {
      setCustomRange([]);
      return;
    }

    setCustomRange([]);

    const range = [
      {
        key: 'last_30_days',
        label: 'Last 30 Days',
        value: [dayjs().subtract(30, 'day').startOf('day'), dayjs().endOf('day')],
      },
      {
        key: 'last_60_days',
        label: 'Last 60 Days',
        value: [dayjs().subtract(60, 'day').startOf('day'), dayjs().endOf('day')],
      },
      {
        key: 'last_90_days',
        label: 'Last 90 Days',
        value: [dayjs().subtract(90, 'day').startOf('day'), dayjs().endOf('day')],
      },
      ...staticRanges,
    ];
    const matchedPreset = range.find((preset) => preset.key === value);
    const [start, end] = matchedPreset.value;

    setDate({
      date_from: start.format('YYYY-MM-DD'),
      date_to: end.format('YYYY-MM-DD'),
      change_global: true,
      date_key: 'global',
    });
  };

  return (
    <div className='w-full gap-4 p-4 bg-white rounded-b-lg '>
      <div className='flex items-center gap-4 mb-4'>
        <Radio.Group
          value={range}
          onChange={handleRangeChange}
          optionType='button'
          buttonStyle='solid'
          className='font-medium'
        >
          <Radio.Button value='last_7_days'>7d</Radio.Button>
          <Radio.Button value='last_30_days'>30d</Radio.Button>
          <Radio.Button value='last_60_days'>60d</Radio.Button>
          <Radio.Button value='last_90_days'>90d</Radio.Button>
          <Radio.Button value='custom' className={range === 'custom' && '!p-0'}>
            {range === 'custom' ? (
              <DateRangePicker
                variant='outlined'
                className='h-full w-full !border-none rounded-l-none'
                size='small'
                allowClear={false}
                value={customRange}
                onChange={(value) => console.log(value)}
              />
            ) : (
              <CalendarOutlined />
            )}
          </Radio.Button>
        </Radio.Group>
      </div>

      <div
        className='grid w-full h-full gap-4 md:grid-cols-1'
        style={{ border: '1px solid #e1e1e1', borderRadius: 8 }}
      >
        <JourneyReport
          title='What are the top events triggered by this user?'
          date_key='eventsOverview'
        >
          <EventsOverviewChart />
        </JourneyReport>
      </div>
      {/* <div className='mt-3' style={{ border: '1px solid #e1e1e1 ', borderRadius: 8 }}>
        <JourneyReport title='Most Viewed Pages by Period' date_key='frequentPages'>
          <FrequentPagesTable />
        </JourneyReport>
      </div> */}
    </div>
  );
};

export default InsightCard;
